import { Controller } from "@hotwired/stimulus"
import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'
import typescript from 'highlight.js/lib/languages/typescript'
import python from 'highlight.js/lib/languages/python'
import ruby from 'highlight.js/lib/languages/ruby'
import xml from 'highlight.js/lib/languages/xml'
import css from 'highlight.js/lib/languages/css'
import json from 'highlight.js/lib/languages/json'
import bash from 'highlight.js/lib/languages/bash'
import sql from 'highlight.js/lib/languages/sql'
import plaintext from 'highlight.js/lib/languages/plaintext'
import 'highlight.js/styles/github-dark.css'

// Register highlight.js languages
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('typescript', typescript)
hljs.registerLanguage('python', python)
hljs.registerLanguage('ruby', ruby)
hljs.registerLanguage('html', xml)
hljs.registerLanguage('xml', xml)
hljs.registerLanguage('css', css)
hljs.registerLanguage('json', json)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('sql', sql)
hljs.registerLanguage('plaintext', plaintext)

export default class extends Controller {
  connect() {
    this.highlightAll()
  }

  highlightAll() {
    const codeBlocks = this.element.querySelectorAll('pre code')
    codeBlocks.forEach(block => {
      // Get language from class (CKEditor adds language-xxx class)
      const langClass = Array.from(block.classList).find(c => c.startsWith('language-'))
      if (langClass) {
        const lang = langClass.replace('language-', '')
        if (hljs.getLanguage(lang)) {
          hljs.highlightElement(block)
        }
      } else {
        // Try auto-detection if no language specified
        hljs.highlightElement(block)
      }
    })
  }
}
